import React from 'react';
import SelectEntity from '@/components/SelectEntity';
import SearchQuery from '@/utils/SearchQuery';
import { ApplicationState } from '@/store/types';
import { StringSet } from '@/utils/setTypes';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import resourceProvider from '@/lib/resources';
import { ResourceDTO } from '@/dtos/resource';
import { PageDTO } from '@/dtos/generics';

type Entity = ResourceDTO & {
  label: string;
  value: string;
};

type ResourceFieldProps = {
  value: string;
  onChange: StringSet;
  filter?: SearchQuery;
};

const ResourceField: React.FC<ResourceFieldProps> = ({
  value,
  onChange,
  filter,
}) => {
  const { t: translation } = useTranslation();

  const userCompanyId = useSelector(
    (state: ApplicationState) => state.user.data.companyId
  );

  const hasMasterCompanyFeature = useSelector((state: ApplicationState) =>
    state.user.data.features?.includes('master_company')
  );

  const loadResources = async (
    searchFilter: SearchQuery
  ): Promise<PageDTO<Entity>> => {
    try {
      const query = filter ? filter.merge(searchFilter) : searchFilter;

      if (!hasMasterCompanyFeature) {
        query.equals('companyId', userCompanyId);
      }

      if (!query.params.some((param) => param.key === 'active')) {
        query.equals('active', 'true');
      }

      const queryParams = query.getQueryParams(true);

      const resources = await resourceProvider.listAllWithFilters(queryParams);

      const data = resources.map((resource) => ({
        ...resource,
        label: resource.name,
        value: resource.id,
      }));

      return {
        data,
        total: data.length,
        currentPage: 1,
      };
    } catch (error) {
      console.error('Erro ao carregar recursos:', error);
      throw new Error(translation('error.loading_resources'));
    }
  };

  return (
    <SelectEntity<Entity>
      loadItems={loadResources}
      onChange={onChange}
      value={value}
      placeholder={translation('select.placeholder.selectId')}
    />
  );
};

export default ResourceField;
